import { isSet } from '../utils/isSet';

class Masonry {
    constructor (domNode) {
        this.domNode = domNode;
        this.columns = Array.from(this.domNode.querySelectorAll('[masonry-column]'));
        this.items = Array.from(this.domNode.querySelectorAll('[masonry-item]'));
        this.init();
    }

    init(){
        this.domNode.classList.add('has-initialised');
        this.update();
        window.addEventListener('resize', this.onWindowResize.bind(this));
        window.addEventListener('load', this.onLoad.bind(this));
    }

    update(){
        this.updateColumns();
        this.updateItems();
        this.layout();
    }

    updateColumns(){
        this.columns = Array.from(this.domNode.querySelectorAll('[masonry-column]'));
    }

    updateItems(){
        this.items = Array.from(this.domNode.querySelectorAll('[masonry-item]'));
    }

    getActiveColumns(){
        return this.columns.filter( function( column ) {
            const style = getComputedStyle( column );
            return style.display !== "none";
        });
    }

    layout(){
        this.activeColumns = this.getActiveColumns();
        this.#layout();
    }

    #layout(){
        if(!isSet(this.columnHeights)) {
            this.columnHeights = this.activeColumns.map( function() {
                return 0;
            });
        }
        this.layoutItems( this.items );
    }

    layoutItems(){
        this.items.forEach((item) => {
            this.layoutItem(item);
        });
    }

    layoutItem(item){
        this.measureColumnHeight();
        let minHeight = Math.min.apply( Math, this.columnHeights );
        let index = this.columnHeights.indexOf( minHeight );
        this.activeColumns[ index ].appendChild( item );
        this.columnHeights[ index ] += item.offsetHeight || 1;
    }

    append(items){
        this.items = this.items.concat( items );
        this.#layout();
    }

    prepend(items){
        this.items = items.concat( this.items );
        this.#layout();
    }

    measureColumnHeight(){
        const boundingRect = this.domNode.getBoundingClientRect();

        this.activeColumns.forEach(( column, i ) => {
            const lastChild = column.lastElementChild;

            if(!isSet(lastChild)) return;
            const lastChildRect = column.lastElementChild.getBoundingClientRect();

            if(!isSet(lastChildRect)) return;
            this.columnHeights[ i ] = lastChildRect.bottom;
        });
    }

    onWindowResize(){
        clearTimeout( this.resizeTimeout );
        this.resizeTimeout = setTimeout( function() {
            this.onDebouncedResize();
        }.bind( this ), 20 );
    }

    onDebouncedResize(){
        const activeColumns = this.getActiveColumns();
        let isSameLength = activeColumns.length == this.activeColumns.length;
        let isSameColumns = true;

        this.activeColumns.forEach( function( column, i ) {
            isSameColumns = isSameColumns && column == activeColumns[i];
        });

        if ( isSameLength && isSameColumns ) return;

        this.activeColumns = activeColumns;
        this.#layout();
    }

    onLoad(){
        this.measureColumnHeight();
    }
}

export { Masonry }